import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';
import { scoreToFillColor, scoreToBorderColor, scoreToLabel } from '../../utils/stewardshipColors';

export default function StewardshipPolygonLayer({ assignments = [], speciesName = '', interactive = true }) {
  if (!assignments.length) return null;

  return assignments.map((a) => {
    if (!a.geometry) return null;

    const fillColor   = scoreToFillColor(a.score);
    const borderColor = scoreToBorderColor(a.score);

    const style = {
      fillColor:   fillColor || 'transparent',
      fillOpacity: fillColor ? 1 : 0,
      color:       borderColor,
      weight:      2,
      opacity:     0.8,
    };

    const label = a.citizenLabel || scoreToLabel(a.score);
    const labelColor = a.score < 0 ? '#dc2626' : a.score > 0 ? '#16a34a' : '#64748b';

    return (
      <GeoJSON
        key={`${a.assignmentId}-${interactive}`}
        data={a.geometry}
        interactive={interactive}
        style={style}
      >
        {interactive && <Popup>
          <div style={{ minWidth: 200, maxWidth: 280, lineHeight: 1.6, fontSize: 13 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>{a.polygonName}</div>
            {speciesName && <div style={{ color: '#64748b', fontSize: 12, marginBottom: 8 }}>{speciesName}</div>}
            <div style={{ fontWeight: 700, color: labelColor, fontSize: 14, marginBottom: 6 }}>{label}</div>
            {a.summary && (
              <div style={{ color: '#374151', marginBottom: 6 }}>{a.summary}</div>
            )}
            {a.season && a.season !== '' && (
              <div style={{ fontSize: 12, color: '#64748b' }}>
                Season: {a.season === 'all_seasons' ? 'All seasons' : a.season.charAt(0).toUpperCase() + a.season.slice(1)}
              </div>
            )}
            {a.lastReviewedAt && (
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                Last reviewed: {new Date(a.lastReviewedAt).toLocaleDateString()}
              </div>
            )}
            <div style={{ fontSize: 10, color: '#cbd5e1', marginTop: 6 }}>
              RSMIN stewardship guidance. Does not determine legal harvesting permissions.
            </div>
          </div>
        </Popup>}
      </GeoJSON>
    );
  });
}
